import { render, staticRenderFns } from "./infocredit.vue?vue&type=template&id=332bad82"
import script from "./infocredit.vue?vue&type=script&lang=js"
export * from "./infocredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports